@if (politician) {
  <div class="card h-100">
    <div class="card-body">
      <div class="d-flex flex-lg-row flex-column">
        <div class="d-flex flex-column me-3">
          <a [routerLink]="'/stakeholder/' + politician._id">
            @if (politician.organ === 'Camera' || politician.organ === 'Senato' || politician.organ === 'European Parliament') {
              <img class="rounded-sm"
                [src]="politician.image" width="90" height="124" alt="Profile pic">
            }
            @if (!politician.organ) {
              <img class="img-100 objectfit-cover rounded-sm" [src]="politician.socials?.twitter?.profile_picture || profilePics.default" alt="Profile pic">
            }
          </a>
        </div>
        <div class="d-flex flex-column">
          <div class="card-title d-flex flex-row mb-1">
            <a class="h5" [routerLink]="'/stakeholder/' + politician._id">
              {{politician.firstName}} {{politician.lastName}}
            </a>
            @if (isDetailsPage) {
              <app-delete-btn-admin (click)="deletePolitician(politician)"></app-delete-btn-admin>
            }
            @if (politician.organ === 'Camera' || politician.email?.includes('@camera')) {
<a class="ms-2" [href]="'https://www.camera.it/leg' + politician._legislatures[politician._legislatures.length-1]?.num + '/29?shadow_deputato=' + politician.personaId + '&idLegislatura=' + politician._legislatures[politician._legislatures.length-1]?.num" target="_blank"
             data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="Camera.it profile">
            <img class="img-20 img-rounded" [src]="profilePics.camera" alt="">
          </a>
}
          @if (politician.organ === 'Senato' || politician.email?.includes('@senato')) {
<a class="ms-2" [href]="'https://www.senato.it/loc/link.asp?tipodoc=sattsen&leg=' + politician._legislatures[politician._legislatures.length-1]?.num + '&id=' + politician.personaId" target="_blank"
             data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="Senato.it profile">
            <img class="img-20 img-rounded" [src]="profilePics.senato" alt="">
          </a>
}
          @if (politician.organ === 'European Parliament' || politician.email?.includes('@europarl')) {
              <a class="ms-2" [href]="'https://www.europarl.europa.eu/meps/en/' + politician.personaId" target="_blank"
                data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="Europa.eu profile">
                <img class="img-20 img-rounded" [src]="profilePics.eu" alt="">
              </a>
            }
            @if (politician.email) {
              <a class="ms-2 text-dark" [href]="'mailto:' + politician.email" target="_blank"
                data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="Email">
                <i class="fa fa-envelope-o"></i>
              </a>
            }
            <a class="ms-2" [href]="'https://it.wikipedia.org/w/index.php?title=Speciale:Ricerca&go=Go&ns0=1&search=' + politician.firstName + ' ' + politician.lastName" target="_blank"
              data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="Wikipedia search">
              <img class="img-20 img-rounded" [src]="profilePics.wikipedia" alt="Wikipedia search">
            </a>
            <a class="ms-2" [href]="'https://www.google.com/search?q=' + politician.firstName + '+' + politician.lastName" target="_blank"
              data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="Google search">
              <img class="img-20 img-rounded" [src]="profilePics.google" alt="">
            </a>
            <app-socials [item]="politician" side="right" text="no"></app-socials>
          </div>
          @if (politician._party) {
            <div>
              <img class="img-25 img-rounded" [src]="politician._party.socials?.twitter?.profile_picture || profilePics.default" alt="">
              {{politician._party.name}}
              @if (isDetailsPage) {
                <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-stakeholder-details-modal" (click)="updatePolitician('_party')">
                  <i class="fa fa-pencil"></i>
                </button>
              }
            </div>
          }
          @if (!politician._party && isDetailsPage) {
            <div class="mt-1">
              <button class="btn btn-sm btn-primary py-0 px-1 ms-1" data-bs-toggle="modal" data-bs-target="#edit-stakeholder-details-modal" (click)="updatePolitician('_party')">
                <i class="fa fa-plus-circle"></i> Add party
              </button>
            </div>
          }
          @if (politician._partyeu) {
            <div class="mt-1">
              <img class="img-25 img-rounded" [src]="politician._partyeu.socials?.twitter?.profile_picture || profilePics.default" alt="">
              {{politician._partyeu.name}}
              @if (isDetailsPage) {
                <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-stakeholder-details-modal" (click)="updatePolitician('_partyeu')">
                  <i class="fa fa-pencil"></i>
                </button>
              }
            </div>
          }
          @if (!politician._partyeu && politician.organ === 'European Parliament' && isDetailsPage) {
            <div class="mt-1">
              <button class="btn btn-sm btn-primary py-0 px-1 ms-1" data-bs-toggle="modal" data-bs-target="#edit-stakeholder-details-modal" (click)="updatePolitician('_partyeu')">
                <i class="fa fa-plus-circle"></i> Add party EU
              </button>
            </div>
          }
          <div class="mt-1">
            @if (profilePics[politician.organ?.toLowerCase()]) {
              <img class="img-25 img-rounded me-1" [src]="profilePics[politician.organ?.toLowerCase()]" alt=""
                data-bs-toggle="tooltip" data-placement="top" data-delay="350" [title]="politician.organ">
            }
            @if (!profilePics[politician.organ?.toLowerCase()]) {
              <i class="fa fa-briefcase fa-fw me-1"></i>
            }
            @if (politician.organ === 'Camera' && politician.job === 'Membro') {
              <span>Deputato</span>
            }
            @if (politician.organ === 'Senato' && politician.job === 'Membro') {
              <span>Senatore</span>
            }
            @if (politician.organ === 'European Parliament') {
              <span>MEP</span>
            }
            @if (!politician.organ || politician.job !== 'Membro') {
              <span>{{politician.job}}</span>
            }
            @if (politician._partyeu && politician.country) {
              <small class="ms-1">({{politician.country}}) </small>
              } @if (politician.partyLeader) {
              <small>- Leader di partito</small>
            }
            @if (isDetailsPage) {
              <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-stakeholder-details-modal" (click)="updatePolitician('job')">
                <i class="fa fa-pencil"></i>
              </button>
            }
          </div>
          @if (politician.category === 'media' && politician._media) {
            <div class="mt-1">
              <i class="fa fa-newspaper-o fa-fw"></i>
              {{politician._media.name}}
              @if (isDetailsPage) {
                <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-stakeholder-details-modal" (click)="updatePolitician('_media')">
                  <i class="fa fa-pencil"></i>
                </button>
              }
            </div>
          }
          @if (!politician._media && politician.category === 'media' && isDetailsPage) {
            <div class="mt-1">
              <button class="btn btn-sm btn-primary py-0 px-1 ms-1" data-bs-toggle="modal" data-bs-target="#edit-stakeholder-details-modal" (click)="updatePolitician('_media')">
                <i class="fa fa-plus-circle"></i> Add media
              </button>
            </div>
          }
          @if (politician.office) {
            <div class="mt-1">
              <img class="img-25 img-rounded" [src]="profilePics.ministero" alt=""
                data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="Ministry">
              {{politician.office}}
              @if (isDetailsPage) {
                <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-stakeholder-details-modal" (click)="updatePolitician('office')">
                  <i class="fa fa-pencil"></i>
                </button>
              }
            </div>
          }
          @if (!politician.office && politician.category === 'institutions' && politician.organ !== 'European Parliament' && isDetailsPage) {
            <div class="mt-1">
              <button class="btn btn-sm btn-primary py-0 px-1 ms-1" data-bs-toggle="modal" data-bs-target="#edit-stakeholder-details-modal" (click)="updatePolitician('office')">
                <i class="fa fa-university"></i> Add ministry
              </button>
            </div>
          }
          @if (politician._commissions?.length) {
            <div class="mt-1">
              <img class="img-25 img-rounded me-1" [src]="profilePics.commissione" alt=""
                data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="Commission">
              @for (commission of politician._commissions; track commission._id; let last = $last) {
                <span>{{commission.name}} ({{commission.roman}}) @if (commission2role[commission._id]) {
                  <small>({{commission2role[commission._id]}})</small>
                  }@if (!last) {
                  <span>, </span>
                }</span>
              }
            </div>
          }
          @if (politician._governments?.length) {
            <div class="mt-1">
              <img class="img-25 img-rounded me-1" [src]="profilePics.governo" alt=""
                data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="Government">
              @for (government of politician._governments; track government._id; let last = $last) {
                <span>{{government.name}}@if (!last) {
                  <span>, </span>
                }</span>
              }
              @if (isDetailsPage) {
                <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-stakeholder-details-modal" (click)="updatePolitician('_governments')">
                  <i class="fa fa-pencil"></i>
                </button>
              }
            </div>
          }
          @if (!politician._governments?.length && politician.category === 'institutions' && politician.organ !== 'European Parliament' && isDetailsPage) {
            <div class="mt-1">
              <button class="btn btn-sm btn-primary py-0 px-1 ms-1" data-bs-toggle="modal" data-bs-target="#edit-stakeholder-details-modal" (click)="updatePolitician('_governments')">
                <i class="fa fa-plus-circle"></i> Add government
              </button>
            </div>
          }
          @if (politician._legislatures?.length) {
            <div class="mt-1">
              <img class="img-25 img-rounded me-1" [src]="profilePics.legislature" alt=""
                data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="Legislature">
              @for (legislature of politician._legislatures; track legislature._id; let last = $last) {
                <span>{{legislature.roman}}@if (!last) {
                  <span>, </span>
                }</span>
              }
              @if (isDetailsPage) {
                <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-stakeholder-details-modal" (click)="updatePolitician('_legislatures')">
                  <i class="fa fa-pencil"></i>
                </button>
              }
            </div>
          }
          @if (!politician._legislatures?.length && politician.category === 'institutions' && politician.organ !== 'European Parliament' && isDetailsPage) {
            <div class="mt-1">
              <button class="btn btn-sm btn-primary py-0 px-1 ms-1" data-bs-toggle="modal" data-bs-target="#edit-stakeholder-details-modal" (click)="updatePolitician('_legislatures')">
                <i class="fa fa-plus-circle"></i> Add legislature
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}